export const HIGHLIGHT_CLICKED = 'HIGHLIGHT_CLICKED';
